import styled from "styled-components";

export const StyledPaymentMethod = styled.div`
    width: 100%;
    min-width: 280px;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    &.border-bottom {
        border-bottom: 1px solid #693510;
        padding-bottom: 20px;
    }
    button {
        background: linear-gradient(180deg, ${(props: any) => props.colorOne} 0%, ${(props: any) => props.colorTwo} 100%);
        cursor: pointer;
        color: white;
        height: 60px;
        font-size: 20px;
        border: 0;
        outline: 0;
        border-radius: 7px;
        margin-bottom: 10px;
        letter-spacing: 0.8px;
        width: 100%;
    }
    div {
        width: 160px;
        display: flex;
        justify-content: space-between;
    }
` as any;
